module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/level-3_start-442837f0b16c00f643a0e2c24ea2764b.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/level-3_start.png
// module id = 429
// module chunks = 2